import { DocumentNode, QueryOptions } from 'apollo-boost';
import { GraphQLClient } from 'types';

export const createQuery =
  <V, T>(doc: DocumentNode) =>
  (client: GraphQLClient, options: Omit<QueryOptions<V>, 'query'>) =>
    client.query<T, V>({
      query: doc,
      ...options,
    });
